import gql from 'graphql-tag'
import { client } from '../ApolloClient'

const BRANCH_SMS_FROM_QUERY = gql`
    query BranchSmsFromDefault($customId: String!) {
        branch(customId: $customId) {
            id
            branchSettings(key_Name: "SMS_FROM_DEFAULT") {
                edges {
                    node {
                        id
                        value
                    }
                }
            }
        }
    }
`

export const GetSmsNumberFromBranchSettings = async (customId) => {
    if (!customId) return null

    const response = await client.query({
        query: BRANCH_SMS_FROM_QUERY,
        variables: { customId },
        fetchPolicy: 'no-cache'
    })

    return response?.data?.branch?.branchSettings?.edges?.[0]?.node?.value || null
}
